import React, { useContext } from 'react';
import { number, arrayOf, shape, bool } from 'prop-types';
import classNames from 'classnames';
import { CardActions, Button } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { showBelowSmBreakpoint, showAboveSmBreakpoint } from '../../constants/responsiveClassNames';
import ListCarousel from './ListCarousel';
import ListsCompactList from './ListsCompactList';

const ListsActions = ({ isMobile }) => {
  return (isMobile ? (
    <div className={classNames(showBelowSmBreakpoint, 'sui-mt-auto')}>
      <CardActions>
        <Button fullWidth href="/list/view/summary">View All Lists</Button>
      </CardActions>
    </div>
  ) : null);
};

const ListsContainer = ({ list, maxMobileListSize }) => {
  const experienceContext = useContext(ExperienceContext);
  const { channel } = experienceContext;
  const isMobile = channel === 'mobile';

  return (
    <div
      data-testid="lists-container"
      id="user-lists-v2"
      className="sui-@container sui-h-full sui-flex sui-flex-col sui-justify-start sui-grow"
    >

      {isMobile ? (
        <div>
          <ListsCompactList
            lists={list}
            maxMobileListSize={maxMobileListSize}
          />
        </div>
      ) : (
        <div>
          <ListCarousel
            lists={list}
          />
        </div>
      )}
      <ListsActions isMobile={isMobile} />
    </div>
  );
};

ListsContainer.propTypes = {
  list: arrayOf(shape({})),
  maxMobileListSize: number
};
ListsContainer.defaultProps = {
  list: [],
  maxMobileListSize: 4
};

ListsActions.propTypes = {
  isMobile: bool
};

ListsActions.defaultProps = {
  isMobile: false
};
export default ListsContainer;
